import React from "react";
import Select from "react-select";

const RSelect = ({ disable, isClearable, ...props }) => {
  return (
    <div className="form-control-select">
      <Select
        isClearable={isClearable}
        isDisabled={disable}
        className={`react-select-container ${props.className ? props.className : ""}`}
        classNamePrefix="react-select"
        {...props}
      />
    </div>
  );
};

export default RSelect;
